import SuperMerchantBeneficiaries from 'modules/beneficiaries/components/SuperMerchantBeneficiaries';

function SuperMerchantBeneficiariesPage() {
  return <SuperMerchantBeneficiaries />;
}

export default SuperMerchantBeneficiariesPage;
